import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/docs/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "dataset-upload"
    }}>{`Dataset upload`}</h1>
    <p>{`This endpoint allows for uploading a NeTEx dataset into Entur import and validation pipeline.
It provides the same feature as a manual upload from the Operator Portal application.`}</p>
    <p><a parentName="p" {...{
        "href": "https://petstore.swagger.io/?url=https://api.entur.io/timetable/v1/timetable-management/openapi.json#/default/upload"
      }}>{`See the API reference on the Swagger Petstore`}</a></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Endpoint URI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><del parentName="td">{`POST `}<a parentName="del" {...{
                "href": "https://api.entur.io/timetable-admin/v1/timetable/upload/%7Bcodespace%7D"
              }}>{`https://api.entur.io/timetable-admin/v1/timetable/upload/{codespace}`}</a></del>{` (deprecated)`}<br />{`POST `}<a parentName="td" {...{
              "href": "https://api.entur.io/timetable/v1/timetable-management/datasets/%7Bcodespace%7D"
            }}>{`https://api.entur.io/timetable/v1/timetable-management/datasets/{codespace}`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{codespace}: lowercase codespace attributed to the data provider. Examples: rut, sky, vyg, …`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Payload`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An HTTP multipart body containing the NeTEx zip archive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A correlation id that can be used to track the progress of the import. See `}<a parentName="td" {...{
              "href": "#import-status"
            }}>{`Import status`}</a>{` .`}<br />{`Example:`}<br />{`{"correlationId":"a4cseaaf-fb52-4522-b7a8-249fawas54f2"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"200": OK - the dataset has been received successfully (this is only a technical acknowledgement, before applying any validation rule. The dataset may be rejected further down in the validation pipeline)`}<br />{`"401": Unauthorized - the authorization token is missing or has expired.`}<br />{`"403": Forbidden - the authorization token is present, but it does not provide sufficient privileges to perform the operation.`}<br />{`"404": Not Found - most likely a typo in the request URL.`}<br />{`"500": Internal Server Error - a processing error on Entur's side.`}</td>
        </tr>
      </tbody>
    </table>
    <h1 {...{
      "id": "dataset-download"
    }}>{`Dataset download`}</h1>
    <p>{`This endpoint gives access to private NeTEx datasets not available on Entur open data portal.
These datasets include, in addition to the data available on the open data portal, the following private data:`}</p>
    <ul>
      <li parentName="ul">{`NeTEx Block data`}</li>
      <li parentName="ul">{`DeadRuns`}</li>
      <li parentName="ul">{`Lines and Service Journeys with restricted publication`}</li>
    </ul>
    <p>{`This dataset is time-filtered (past trips are removed) and content-filtered (unknown NeTEx entities are filtered out).
Datasets that failed validation are not published on this endpoint.
To access the original NeTEx dataset sent by the data provider, without any alteration, use instead `}<a parentName="p" {...{
        "href": "#latest-original-dataset-download"
      }}>{`Latest original dataset download endpoint`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://petstore.swagger.io/?url=https://api.entur.io/timetable/v1/timetable-management/openapi.json#/default/download"
      }}>{`See the API reference on the Swagger Petstore`}</a></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Endpoint URI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><del parentName="td">{`GET `}<a parentName="del" {...{
                "href": "https://api.entur.io/timetable-admin/v1/timetable/download_netex_blocks/%7Bcodespace%7D"
              }}>{`https://api.entur.io/timetable-admin/v1/timetable/download_netex_blocks/{codespace}`}</a></del>{` (deprecated)`}<br />{`GET `}<a parentName="td" {...{
              "href": "https://api.entur.io/timetable/v1/timetable-management/datasets/%7Bcodespace%7D/filtered"
            }}>{`https://api.entur.io/timetable/v1/timetable-management/datasets/{codespace}/filtered`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{codespace}: lowercase codespace attributed to the data provider. Examples: rut, sky, vyg, …`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The NeTEx zip archive as the HTTP body response.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"200": OK`}<br />{`"401": Unauthorized - the authorization token is missing or has expired.`}<br />{`"403": Forbidden - the authorization token is present, but it does not provide sufficient privileges to perform the operation.`}<br />{`"404": Not Found - most likely a typo in the request URL.`}<br />{`"500": Internal Server Error - a processing error on Entur's side.`}</td>
        </tr>
      </tbody>
    </table>
    <h1 {...{
      "id": "latest-original-dataset-download"
    }}>{`Latest original dataset download`}</h1>
    <p>{`This endpoint provides access to the most recent validated Netex datasets.
Datasets that failed validation are not published on this endpoint.
This is the file uploaded by the data provider, without any alteration. See `}<a parentName="p" {...{
        "href": "#dataset-download"
      }}>{`Dataset-download`}</a>{` for retrieving a post-processed version of this dataset containing private data.`}</p>
    <p><a parentName="p" {...{
        "href": "https://petstore.swagger.io/?url=https://api.entur.io/timetable/v1/timetable-data/openapi.json#/TimetableData/getLatestDataset"
      }}>{`See the API reference on the Swagger Petstore`}</a></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Endpoint URI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GET `}<a parentName="td" {...{
              "href": "https://api.entur.io/timetable/v1/timetable-data/datasets/%7Bcodespace%7D/latest"
            }}>{`https://api.entur.io/timetable/v1/timetable-data/datasets/{codespace}/latest`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{codespace}: lowercase codespace attributed to the data provider. Examples: rut, sky, vyg, …`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The NeTEx zip archive as the HTTP body response.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"200": OK`}<br />{`"401": Unauthorized - the authorization token is missing or has expired.`}<br />{`"403": Forbidden - the authorization token is present, but it does not provide sufficient privileges to perform the operation.`}<br />{`"404": Not Found - most likely a typo in the request URL.`}<br />{`"500": Internal Server Error - a processing error on Entur's side.`}</td>
        </tr>
      </tbody>
    </table>
    <h1 {...{
      "id": "versioned-original-datasets-download"
    }}>{`Versioned original datasets download`}</h1>
    <p>{`This endpoint provides access to past recent versions of validated Netex datasets, including the latest one.
Datasets that failed validation are not published on this endpoint.`}</p>
    <p><a parentName="p" {...{
        "href": "https://petstore.swagger.io/?url=https://api.entur.io/timetable/v1/timetable-data/openapi.json#/TimetableData/getDataset"
      }}>{`See the API reference on the Swagger Petstore`}</a></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Endpoint URI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GET `}<a parentName="td" {...{
              "href": "https://api.entur.io/timetable/v1/timetable-data/datasets/%7Bcodespace%7D/version/%7BimportKey%7D"
            }}>{`https://api.entur.io/timetable/v1/timetable-data/datasets/{codespace}/version/{importKey}`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{codespace}: lowercase codespace attributed to the data provider. Examples: rut, sky, vyg, …`}<br />{`{importKey}: the unique identifier for this import.`}<br />{`The import key can be retrieved from the following endpoint: `}<a parentName="td" {...{
              "href": "#list-of-versioned-original-datasets"
            }}>{`List of versioned original datasets`}</a>{`.`}<br />{`Internal Entur systems can also retrieve the import key from the following Kafka topic: rutedata-dataset-import-event-production`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The NeTEx zip archive as the HTTP body response.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"200": OK`}<br />{`"401": Unauthorized - the authorization token is missing or has expired.`}<br />{`"403": Forbidden - the authorization token is present, but it does not provide sufficient privileges to perform the operation.`}<br />{`"404": Not Found - most likely a typo in the request URL.`}<br />{`"500": Internal Server Error - a processing error on Entur's side.`}</td>
        </tr>
      </tbody>
    </table>
    <h1 {...{
      "id": "list-of-versioned-original-datasets"
    }}>{`List of versioned original datasets`}</h1>
    <p>{`This endpoint provides access to the list of the 10 latest versions of validated Netex datasets.
Datasets that failed validation are not published on this endpoint.`}</p>
    <p><a parentName="p" {...{
        "href": "https://petstore.swagger.io/?url=https://api.entur.io/timetable/v1/timetable-data/openapi.json#/TimetableData/getDatasetVersions"
      }}>{`See the API reference on the Swagger Petstore`}</a></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Endpoint URI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GET `}<a parentName="td" {...{
              "href": "https://api.entur.io/timetable/v1/timetable-data/datasets/%7Bcodespace%7D/versions"
            }}>{`https://api.entur.io/timetable/v1/timetable-data/datasets/{codespace}/versions`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{codespace}: lowercase codespace attributed to the data provider. Examples: rut, sky, vyg, …`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The list of the last 10 previously imported datasets, identified by their import key and date of import.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"200": OK`}<br />{`"401": Unauthorized - the authorization token is missing or has expired.`}<br />{`"403": Forbidden - the authorization token is present, but it does not provide sufficient privileges to perform the operation.`}<br />{`"404": Not Found - most likely a typo in the request URL.`}<br />{`"500": Internal Server Error - a processing error on Entur's side.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "example-response"
    }}>{`Example response:`}</h2>
    <pre><code parentName="pre" {...{}}>{`[
{
"importKey": "ent_2025-01-11T19_08_10.796",
"creationDate": "2025-01-11T18:08:34.45Z"
},
{
"importKey": "ent_2025-01-11T19_40_59.93",
"creationDate": "2025-01-11T18:41:18.172Z"
}
]
`}</code></pre>
    <h1 {...{
      "id": "import-status"
    }}>{`Import status`}</h1>
    <p>{`This endpoint provides access to the status of a given import process.`}</p>
    <p><a parentName="p" {...{
        "href": "https://petstore.swagger.io/?url=https://api.entur.io/timetable/v1/timetable-events/openapi.json#/TimetableDataDeliveryStatus/getDataDeliveryStatus"
      }}>{`See the API reference on the Swagger Petstore`}</a></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Endpoint URI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GET `}<a parentName="td" {...{
              "href": "https://api.entur.io/timetable/v1/timetable-events/status/%7Bcodespace%7D/%7BcorrelationId%7D"
            }}>{`https://api.entur.io/timetable/v1/timetable-events/status/{codespace}/{correlationId}`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{codespace}: lowercase codespace attributed to the data provider. Examples: rut, sky, vyg, …`}<br />{`{correlationId}: The correlation id returned by the `}<a parentName="td" {...{
              "href": "#dataset-upload"
            }}>{`Dataset upload endpoint`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The current status of the given import.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Response code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"200": OK`}<br />{`"401": Unauthorized - the authorization token is missing or has expired.`}<br />{`"403": Forbidden - the authorization token is present, but it does not provide sufficient privileges to perform the operation.`}<br />{`"404": Not Found - most likely a typo in the request URL.`}<br />{`"500": Internal Server Error - a processing error on Entur's side.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "example-response-1"
    }}>{`Example response:`}</h2>
    <pre><code parentName="pre" {...{}}>{`{"state":"IN_PROGRESS","date":"2025-08-04T12:49:19.068+02:00","fileName":"Entur-1217-2025-08-01-netex.zip"}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      